/**
 * useSnackbar Hook
 * Global snackbar notifications. Uses snackbarStore (Zustand).
 */

import { useSnackbarStore } from '../stores/snackbarStore';
import type {
  SnackbarOptions,
  SnackbarState,
  SnackbarVariant,
} from '../stores/snackbarStore';

interface UseSnackbarReturn {
  showSnackbar: (
    message: string,
    variant?: SnackbarVariant,
    title?: string,
    options?: SnackbarOptions,
  ) => void;
  snackbar: SnackbarState | null;
}

export const useSnackbar = (): UseSnackbarReturn => {
  const snackbar = useSnackbarStore((s) => s.snackbar);
  const showSnackbar = useSnackbarStore((s) => s.showSnackbar);
  return { showSnackbar, snackbar };
};
